import React from "react";
import "./SiderIcon.scss";
import {toNumber} from "helper/common";
const SiderIcon = props => {
  const {icon, quantity} = props;
  return (
    <div className="sider-icon">
      <div className="icon">{icon}</div>
      {toNumber(quantity) > 0 && <div className="quantity">{quantity}</div>}
    </div>
  );
};
export default SiderIcon;
